import { homePageActionTypes } from "../actions/homePage.actions";

export default function homePageReducer(state = null, action) {
  switch (action.type) {
    case homePageActionTypes.FETCH_HOMEPAGE_DATA_SUCCESS:
      return action.data;
    case homePageActionTypes.CLEAR_HOMEPAGE_DATA:
      return null;
    default:
      return state;
  }
}
